const Validator = (dataCheck) => {
  let emptyField = [];
  return new Promise(function(resolve, reject) {
    for(var prop in dataCheck) {
        if(dataCheck.hasOwnProperty(prop)){
          if (dataCheck[prop] === '') {
            emptyField.push(prop);
          }
        }
    }
    resolve(emptyField)
  });

}

export default Validator;



// WEBPACK FOOTER //
// ./src/lib/validator.js